import { call, put, takeLatest } from 'redux-saga/effects'
import {
  getTimeTrackingList,
  showTimeTracking,
  addTimeLog,
  addTimeLogBackground,
  editTimeTracking,
  deleteTimeLog
} from './timeTracking.reducer'
import Api from '../services/ApiCaller'
import { showMessage } from '../utils'
import { translate } from '../i18n'


export function* getTimeTrackingListRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error } = res
    if (!error) {
      yield put(getTimeTrackingList.success(res))
    }
  } catch (e) {
    yield put(getTimeTrackingList.failure())
  }
  }
function* getTimeTrackingByIdRequest(api: any, { payload }: any) {
    try {
      const { res = {} } = yield call(Api.callServer, api, payload, true)
      const { error } = res
      if (!error) {
        yield put(showTimeTracking.success(res))
      }
    } catch (e) {
      yield put(showTimeTracking.failure())
    }
  }
export function* addTimeLogRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(addTimeLog.success(res))
      showMessage(`${translate('timeTracking.addTimeLogSuccessMessage')}`)
    } else {
      yield put(addTimeLog.failure(message))
    }
  } catch (e) {

    yield put(addTimeLog.failure(payload))
  }
}
export function* addTimeLogRequestBg(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload)
    const { error, message } = res
    if (!error) {
      yield put(addTimeLogBackground.success(res))

    } else {
      yield put(addTimeLogBackground.failure(message))
    }
  } catch (e) {

    yield put(addTimeLogBackground.failure(payload))
  }
}
function* editTimeTrackingRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error } = res
    if (!error) {
      yield put(editTimeTracking.success(res))
      showMessage(`${translate('timeTracking.editTimeLogSuccessMessage')}`)
    }
  } catch (e) {
    yield put(editTimeTracking.failure())
  }
}

function* deleteTimeTrackingRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error } = res
    if (!error) {
      yield put(deleteTimeLog.success({id: payload.billingId}))
      showMessage(`${translate('timeTracking.deleteTimeLogSuccessMessage')}`)
    }
  } catch (e) {
    yield put(deleteTimeLog.failure())
  }
}

export default (api: any) => {
  // send with id to billing
  const getTimeTrackingListApi = (data: any) => {
    return api.get(`/billing`, data)
  }
  const getTimeTrackingByIdApi = (data: any) => api.get(`/billing/${data.patientId}/${data.billingId}`)
  const editTimeTrackingApi = (data: any) => api.put(`/billing/${data.patientId}/${data.billingId}`, data.payload)
  const addTimeLogApi = (data: any) => api.post(`/billing/${data.patientId}`, data.payload)
  const deleteTimeTrackingApi = (data: any) => api.delete(`/billing/${data.patientId}/${data.billingId}`, data.payload)
  return [
    takeLatest(getTimeTrackingList.TRIGGER, getTimeTrackingListRequest, getTimeTrackingListApi),
    takeLatest(showTimeTracking.TRIGGER, getTimeTrackingByIdRequest, getTimeTrackingByIdApi),
    takeLatest(editTimeTracking.TRIGGER, editTimeTrackingRequest, editTimeTrackingApi),
    takeLatest(addTimeLog.TRIGGER, addTimeLogRequest, addTimeLogApi),
    takeLatest(addTimeLogBackground.TRIGGER, addTimeLogRequestBg, addTimeLogApi),
    takeLatest(deleteTimeLog.TRIGGER, deleteTimeTrackingRequest, deleteTimeTrackingApi)

  ]
}
